import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoJuicio, TipoJuicioProps } from '../../interfaces/catalogos/TipoJuicioInterface';

export const TipoJuicio = () => {

    return new Promise<TipoJuicioProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoJuicio/', token)
            .then( ({ data } : { data : TipoJuicioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoJuicio = () => {

    return new Promise<TipoJuicioProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoJuicio/ObtenerTipoJuicio', token)
            .then( ({ data } : { data : TipoJuicioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoJuicio = ( params: TipoJuicioProps ) => {

    return new Promise<TipoJuicioProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoJuicio/Actualizar', params, token)
            .then( ({ data } : { data : TipoJuicioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoJuicio } );
            });

        }

    });

}

export const AgregarTipoJuicio = ( params: TipoJuicioProps ) => {

    return new Promise<TipoJuicioProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoJuicio/Agregar', params, token)
            .then( ({ data } : { data : TipoJuicioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoJuicio } );
            });

        }

    });

}
